import React, { useState, useEffect } from "react";

import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import img from "../Assets/Avatar 6.png";
import icon from "../Assets/Achievement-rafiki 1.png";
import img2 from "../Assets/path.png";
import wishlist from "../Assets/Course app-pana (1) 7.png";
import profileimg from "../Assets/image 147.png";
import icon2 from "../Assets/Button.png";
import icon1 from "../Assets/Link.png";
import Loader from "../Loader/Loader.jsx";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getUserProfile, updateUserProfile } from "../Common/apis.js";
import MyProfile from "./MyProfile.jsx";
import OrderHistory from "./OrderHistory.jsx";
import WishlistSubComponent from "./WishlistSubComponent.jsx";
import Aos from "aos";
import Setting from "./Setting.jsx";
import Skillset from "./Skillset.jsx";


function Profile() {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once
    });
  }, []);
  const [userData, setUserData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const [activeTab2, setActiveTab2] = useState(1);
  const handleTabChange2 = (tabIndex) => {
    setActiveTab2(tabIndex);
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  //  Fetch User Data from API
  const fetchUserProfile = async () => {
    setLoading(true);
    try {
      const response = await getUserProfile();
      setUserData(response.data);
    } catch (error) {
      toast.error("Failed to fetch profile!");
    } finally {
      setLoading(false);
    }
  };

  //  Handle Image Upload
  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("profileImage", file);

    setImageLoading(true);
    try {
      const response = await updateUserProfile(formData);
      setUserData({ ...userData, profileImage: response.data.profileImage });
      toast.success("Profile image updated successfully!");
    } catch (error) {
      toast.error("Failed to update profile image!");
    } finally {
      setImageLoading(false);
    }
  };
  return (
    <>
      <div className="main-div">
        <Navbar />
        <div className="profile-heading">
          <div className="profile-div">
            <div className="flex items-center md:py-0 py-[37px] gap-[22px] overflow-hidden">

              <div className="relative">
                {imageLoading ? (
                  <Loader />
                ) : (
                  <img
                    data-aos="fade-right"
                    src={userData?.profileImage || img}
                    alt="Profile"
                    className="md:h-[128px] h-[74px] md:w-[128px] w-[74px] rounded-full object-cover"
                  />
                )}
                <label
                  htmlFor="profile-upload"
                  className="absolute top-0 left-0 bg-gray-800 text-white p-1 rounded-full cursor-pointer"
                >
                  ✏️
                </label>
                <input
                  type="file"
                  id="profile-upload"
                  accept="image/*"
                  className="hidden"
                  onChange={handleImageChange}
                />
              </div>
              <div className="profile-name">
                {/* <h2>Roland Ricahrds</h2> */}
                <h2 data-aos="fade-up">{userData?.name || "User Name"}</h2>
              </div>
            </div>
            {/* <div className="profile-photo">
              <img src={img} />
            </div> */}
            <div>
              <img data-aos="fade-left" alt="icon" className="md:w-auto w-[81px] md:h-auto h-[81px]" src={icon} />
            </div>
          </div>
        </div>

        <div className="my-profile">
          <div className="my-profile-left">
            <button
              data-aos="fade-right"
              className={`"font-sans font-[400] text-[16px]" ${activeTab === 1 ? "tab-btn active2" : "tab-btn"}`}
              onClick={() => handleTabChange(1)}
            >
              <i className="bi bi-person-circle"></i>Profile
            </button>
            <button
              data-aos="fade-left"
              className={`"font-sans font-[400] text-[16px]" ${activeTab === 2 ? "tab-btn active2" : "tab-btn"}`}
              onClick={() => handleTabChange(2)}
            >
              <i className="bi bi-journal-text"></i> Order History
            </button>
            <button
              data-aos="fade-right"
              className={`"font-sans font-[400] text-[16px]" ${activeTab === 3 ? "tab-btn active2" : "tab-btn"}`}
              onClick={() => handleTabChange(3)}
            >
              <i className="bi bi-hand-index-thumb"></i> Your Skillset Journey
            </button>
            <button
              data-aos="fade-left"
              className={`"font-sans font-[400] text-[16px]" ${activeTab === 4 ? "tab-btn active2" : "tab-btn"}`}
              onClick={() => handleTabChange(4)}
            >
              <i className="bi bi-card-list"></i> Wishlist
            </button>
            {/* <button
              data-aos="fade-right"
              className={`"font-sans font-[400] text-[16px]" ${activeTab === 5 ? "tab-btn active2" : "tab-btn"}`}
              onClick={() => handleTabChange(5)}
            >
              <i className="bi bi-list-stars"></i> Reviews
            </button> */}
            <button
              data-aos="fade-left"
              className={`"font-sans font-[400] text-[16px]" ${activeTab === 6 ? "tab-btn active2" : "tab-btn"}`}
              onClick={() => handleTabChange(6)}
            >
              <i className="bi bi-gear"></i> Setting
            </button>
            <button
              data-aos="fade-right"
              onClick={() => setIsModalOpen(true)}
              className={`"font-sans font-[400] text-[16px] tab-btn"`}
            >
              <img src="/assets/home/icon6.svg" alt="" /> Log Out
            </button>
          </div>
          <div className="my-profile-right">
            <div className="tab-data">
              {activeTab === 1 && (
                <>
                  <MyProfile
                    userData={userData}
                    setUserData={setUserData}
                    fetchUserProfile={fetchUserProfile}
                  />
                </>
              )}
              {activeTab === 2 && (
                <>
                  <OrderHistory />
                </>
              )}

              {activeTab === 3 && (
                <>
                <Skillset />
                  {/* <div className="profile-info">
                    <div className="profile-info-heading overflow-hidden">
                      <h3 data-aos="fade-right">Your Skillset Journey</h3>
                    </div>
                    <br />
                    <br />
                    <img data-aos="flip-up" className="path-img" src={img2} />
                  </div> */}
                </>
              )}
              {activeTab === 4 && (
                <>
                  <WishlistSubComponent />
                  {/* <div className="profile-info">
                    <div className="profile-info-heading">
                      <h3>Wishlist</h3>
                    </div>
                    <br />
                    <br />
                    <div className="wishlist-cards">
                      <div className="wishlist-card">
                        <img src={wishlist} />
                        <br />
                        <h3>AWS Skill Builder</h3>
                        <br />

                        <div className="wish-btn">
                          <button className="white-btn">7hr 24m</button>
                          <button className="yellow-btn">7hr 24m</button>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </>
              )}
              {activeTab === 5 && (
                <>
                  <div className="profile-info overflow-hidden">
                    <div className="profile-info-heading">
                      <h3 data-aos="fade-right" className="pb-[13px]">Reviews</h3>
                    </div>
                    <div className="flex flex-col gap-[12px]">
                      <div className="review-box">
                        <div className="flex md:flex-row overflow-hidden flex-col justify-between md:items-center items-start md:gap-0 gap-[10px]">
                          <div data-aos="fade-right" className="review-profile">
                            <img src={profileimg} />
                            <div className="">
                              <h3>Ronald Richard</h3>
                              <p>8 months ago</p>
                            </div>
                          </div>
                          <div data-aos="fade-left" className="flex gap-[5px] items-center">
                            <img src="/assets/home/vector6.svg" alt="" />
                            <p className="font-[400] font-poppins text-[13px] uppercase tracking-[0.5px] text-[#263238]">5.00 (1.2K)</p>
                            <p className="font-[400] font-poppins text-[13px] uppercase tracking-[0.5px] text-[#6953A3]">(Good)</p>
                          </div>
                        </div>

                        <p data-aos="fade-right" className="md:pt-[23px] pt-[16px] font-400 font-sans text-[14px] text-[#505050] pb-[12px]">
                          I've been using this LMS for several months for my
                          online courses, and it's been a game-changer. The
                          interface is incredibly user-friendly, making it easy
                          for both instructors and students to navigate through
                          the courses. The variety of tools available for creating
                          interactive and engaging content has significantly
                          enhanced the learning experience.
                        </p>

                        <div data-aos="fade-left" className="review-btns">
                          <img src={icon1} />
                          <img src={icon2} />
                        </div>
                      </div>
                      <div className="review-box">
                        <div className="flex justify-between items-center">
                          <div data-aos="fade-right" className="review-profile">
                            <img src={profileimg} />
                            <div className="">
                              <h3>Ronald Richard</h3>
                              <p>8 months ago</p>
                            </div>
                          </div>
                          <div data-aos="fade-left" className="flex gap-[5px] items-center">
                            <img src="/assets/home/vector6.svg" alt="" />
                            <p className="font-[400] font-poppins text-[13px] uppercase tracking-[0.5px] text-[#263238]">5.00 (1.2K)</p>
                            <p className="font-[400] font-poppins text-[13px] uppercase tracking-[0.5px] text-[#6953A3]">(Good)</p>
                          </div>
                        </div>

                        <p data-aos="fade-right" className="pt-[23px] font-400 font-sans text-[14px] text-[#505050] pb-[12px]">
                          I've been using this LMS for several months for my
                          online courses, and it's been a game-changer. The
                          interface is incredibly user-friendly, making it easy
                          for both instructors and students to navigate through
                          the courses. The variety of tools available for creating
                          interactive and engaging content has significantly
                          enhanced the learning experience.
                        </p>

                        <div data-aos="fade-left" className="review-btns">
                          <img src={icon1} />
                          <img src={icon2} />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {activeTab === 6 && (
                <>
                  <Setting />
                  {/* <div className="profile-info overflow-hidden">
                    <div className="profile-info-heading">
                      <h3 data-aos="fade-right">Settings</h3>
                    </div>
                    <p data-aos="fade-left" className="font-[400] font-sans text-[16px] text-[#000000] pt-[6px] pb-[20px] leading-[27px]">
                      You have full control to manage your own account settings
                    </p>
                    <div className="setting-tab">
                      <button
                        data-aos="flip-up"
                        className={
                          activeTab2 === 1 ? "tab-btn-s active" : "tab-btn-s"
                        }
                        onClick={() => handleTabChange2(1)}
                      >
                        Change Password
                      </button>
                      <button
                        data-aos="flip-up"
                        className={
                          activeTab2 === 2 ? "tab-btn-s active" : "tab-btn-s"
                        }
                        onClick={() => handleTabChange2(2)}
                      >
                        Social Profiles
                      </button>
                      <button
                        data-aos="flip-up"
                        className={
                          activeTab2 === 3 ? "tab-btn-s active" : "tab-btn-s"
                        }
                        onClick={() => handleTabChange2(3)}
                      >
                        Linked Accounts
                      </button>
                      <button
                        data-aos="flip-up"
                        className={
                          activeTab2 === 4 ? "tab-btn-s active" : "tab-btn-s"
                        }
                        onClick={() => { handleTabChange2(4); setIsModalOpen1(true) }}
                      >
                        Notifications
                      </button>
                    </div>
                    {activeTab2 === 1 && (
                      <>
                        <div className="profile-info-ips pt-[30px]">
                          <div className="profile-info-ip">
                            <label data-aos="fade-right">Full Name</label>
                            <input data-aos="fade-left" placeholder="Your Name" />
                          </div>
                          <div className="profile-info-ip">
                            <label data-aos="fade-right">Full Name</label>
                            <input data-aos="fade-left" placeholder="Your Name" />
                          </div>
                        </div>
                        <br />
                        <div className="profile-info-ips">
                          <div className="profile-info-ip">
                            <label data-aos="fade-right">Full Name</label>
                            <input data-aos="fade-left" placeholder="Your Name" />
                          </div>
                        </div>
                        <button data-aos="fade-right" className="UpdatePassword font-sans mt-[30px] text-[17px] text-[#263238]">
                          Update Password
                        </button>
                      </>
                    )}
                  </div> */}
                </>
              )}
            </div>
          </div>
        </div>

        <Footer />
      </div>
      <NotificationModal isOpen={isModalOpen1} onClose={() => setIsModalOpen1(false)} />
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}

export default Profile;

const Modal = ({ isOpen, onClose }) => {

  const navigate = useNavigate();
  if (!isOpen) return null;

  const handleLogout = () => {
    localStorage.removeItem("GISUL_USER");
    localStorage.removeItem("GISUL_TOKEN");
    navigate("/login");
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="flex md:pt-[27px] pt-[7px] md:pb-[37px] pb-[22px] items-center justify-center">
          <img src="/assets/home/icon7.svg" className="md:h-[173px] h-[150px] md:w-[173px] w-[150px]" alt="" />
        </div>
        <div className="flex flex-col items-center md:gap-[14px] gap-0">
          <h6 className="font-[700] font-sans md:text-[40px] text-[26px] text-center leading-[-0.32px] text-[#6953A3]">Oh no ! You’re leaving...</h6>
          <h6 className="font-[700] font-sans md:text-[40px] text-[26px] md:pb-[28px] pb-[25px] text-center leading-[-0.32px] text-[#6953A3]">Are You Sure?</h6>
        </div>
        <div className="flex flex-col gap-[16px] md:px-[26px] px-0">
          <button onClick={onClose}  className="py-[14px] text-center w-full rounded-[10px] bg-[#F1E60D] font-sans font-[400] text-[16px] text-[#263238]">Naah, Just kidding</button>
          <button onClick={handleLogout} className="py-[14px] text-center w-full rounded-[10px] bg-[#6953A3] font-sans font-[400] text-[16px] text-[#FFFFFF]">Yes, Log Me Out</button>
        </div>
      </div>
    </div>
  );
};

const NotificationModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h6 className="font-[700] font-sans md:text-[40px] text-[26px] text-center leading-[-0.32px] text-[#6953A3]">Push Notifications</h6>
        <div className="flex md:pt-[27px] pt-[7px] md:pb-[37px] pb-[22px] items-center justify-center">
          <img src="/assets/slider/img6.png" className="md:h-[173px] h-[150px] md:w-[173px] w-[150px]" alt="" />
        </div>
        <div className="flex flex-col items-center md:gap-[14px] gap-0">
          <h6 className="font-[700] font-sans md:text-[20px] text-[16px] md:pb-[28px] pb-[25px] text-center leading-[-0.32px] text-[#6953A3]">Receive push notifications to be updated to latest news.</h6>
        </div>
        <div className="flex flex-col gap-[16px] md:px-[26px] px-0">
          <button className="py-[14px] text-center w-full rounded-[10px] bg-[#F1E60D] font-sans font-[400] text-[16px] text-[#263238]">Subscribe Now</button>
          <button className="py-[14px] text-center w-full rounded-[10px] bg-[#6953A3] font-sans font-[400] text-[16px] text-[#FFFFFF]">Not Now</button>
        </div>
      </div>
    </div>
  );
};

